import React from "react";

import { createRoot } from "react-dom/client";

import App from "./App/App";

const rootElement = document.getElementById("root");

if (rootElement === null) {
  throw new Error("The application root element was not found.");
}

createRoot(rootElement).render(<App />);
